module.exports = __webpack_public_path__ + "img/urls-reports.89bc0910.webp";